import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["emailAddress"],
  _excluded2 = ["phoneNumber"];
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function sendConsentCommunication(_ref) {
  var adapter = _ref.adapter,
    contactId = _ref.contactId,
    to = _ref.to,
    language = _ref.language,
    employeeId = _ref.employeeId,
    medium = _ref.medium;
  return adapter.createRecord('communication', {
    medium: medium,
    category: 'consent_request',
    to: to,
    person: contactId,
    sender: employeeId,
    details: {
      language: language
    }
  });
}
export function createEmailConsent(_ref2) {
  var emailAddress = _ref2.emailAddress,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return sendConsentCommunication(_objectSpread({
    to: emailAddress,
    medium: 'email'
  }, rest));
}
export function createSmsConsent(_ref3) {
  var phoneNumber = _ref3.phoneNumber,
    rest = _objectWithoutProperties(_ref3, _excluded2);
  var phoneNumberDigits = phoneNumber.match(/\d+/g).join('');
  return sendConsentCommunication(_objectSpread({
    to: phoneNumberDigits,
    medium: 'sms'
  }, rest));
}
function sendFileConsent(_x) {
  return _sendFileConsent.apply(this, arguments);
}
function _sendFileConsent() {
  _sendFileConsent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref4) {
    var adapter, contactId, file, consentMethod, response, id;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          adapter = _ref4.adapter, contactId = _ref4.contactId, file = _ref4.file, consentMethod = _ref4.consentMethod;
          _context.next = 3;
          return adapter.createRecord('consent', {
            state: 'accepted',
            consent_method: consentMethod,
            submission_method: 'file_upload',
            person: contactId
          });
        case 3:
          response = _context.sent;
          id = response.data.data.id;
          _context.next = 7;
          return adapter.uploadFile('consent', id, file, file.name);
        case 7:
          return _context.abrupt("return", response);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _sendFileConsent.apply(this, arguments);
}
export function createDocumentConsent(params) {
  return sendFileConsent(_objectSpread({
    consentMethod: 'written'
  }, params));
}
export function createAudioConsent(params) {
  return sendFileConsent(_objectSpread({
    consentMethod: 'verbal'
  }, params));
}
//# sourceMappingURL=index.js.map